import { CalcInputError, fromCents, toCents } from '../../../../shared/calc/money';
import { PL_GROUPS } from '../../../../shared/calc/line-mapping';
import { netRevenueCents } from '../../../../shared/calc/revenue';

const revenueLines = new Set<string>([...PL_GROUPS.revenue, ...PL_GROUPS.contraRevenue]);

/** Adapt API dollars; invalid revenue is unavailable without blocking row edits. */
export function netRevenue(items: readonly { lineItem: string; amount: string | number }[]): number | null {
  try {
    return fromCents(netRevenueCents(items.filter(item => revenueLines.has(item.lineItem)).map(item => ({
      lineItem: item.lineItem,
      amountCents: toCents(item.amount),
    }))));
  } catch (error) {
    if (error instanceof CalcInputError) return null;
    throw error;
  }
}
